seedWebApp.controller('StatusModalController', ['$scope', '$uibModalInstance','ToastService',  'StoreService', 'TranslationService', 'status',
    function ($scope, $uibModalInstance, ToastService, StoreService, TranslationService, status) {

        $scope.item = status;
        if (status == null) {
            $scope.isInserting = true;
        }

        //$scope.titleContactName = $scope.listItem.ContactName;

        $scope.translation = TranslationService.getActiveTranslation();
        $scope.loading = true;
        //$scope.actualYear = (new Date()).getFullYear();


        /*
        ContactService.get(contact.ContactID).then(function (response) {
            $scope.loading = false;
            $scope.error = false;
            $scope.listItem = response.data;

            if ($scope.listItem.ContactGoals) {
                var yearsToAdd = [$scope.actualYear, $scope.actualYear + 1];
                $scope.listItem.ContactGoals = $scope.listItem.ContactGoals.filter(function (e) {
                    var found = yearsToAdd.findIndex(function (year) {
                        return year == e.GoalYear;
                    });
                    if (found != -1) {
                        yearsToAdd.splice(found, 1);
                    }
                    return e.GoalYear <= $scope.actualYear + 1;
                });
                for (var i = 0; i < yearsToAdd.length; i++) {
                    $scope.listItem.ContactGoals.push({ ContactID: $scope.listItem.ContactID, GoalYear: yearsToAdd[i] });
                }
                $scope.listItem.ContactGoals.sort(function (a, b) {
                    return a.GoalYear - b.GoalYear;
                });
            }
        }, function errorFunc(errorDescription) {
            $scope.listItem = [];
            $scope.error = true;
            $scope.errorDescription = errorDescription;
        });
        */        

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
        
        $scope.ok = function () {
            $scope.loading = true;
            var toastID = ToastService.createToast($scope.translation.SavingLoad, '', 0, 'wait');
            StoreService.saveStatus($scope.item).then(
                function () {
                    $scope.loading = false;
                    ToastService.updateToast(toastID, $scope.translation.ActionSuccessfullySaved, '', 4000, 'success');

                    

                    $uibModalInstance.close();
                },
                function (error) {
                    $scope.loading = false;
                    console.log('savePrice error: ');
                    console.log(error.data);
                    var errorMsg = error.data.Message;
                    var errorExc = error.data.ExceptionMessage;
                    ToastService.updateToast(toastID, $scope.translation.ErrorSaving, '', 4000, 'error');
                }
            );
        };
    }
]);
